import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCVb3zDmsm5Gh2aOgVXQEhmpZzuew_XFWQ",
  authDomain: "vuerender-f8354.firebaseapp.com",
  databaseURL: "https://vuerender-f8354.firebaseio.com",
  projectId: "vuerender-f8354"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp;
